//
// GENERATED by KVision
//
package pl.finn.forms.ezw

import org.w3c.fetch.RequestInit
import io.kvision.remote.KVRemoteAgent
import kotlinx.serialization.modules.SerializersModule
import pl.finn.forms.ezw.EzwForm
import pl.finn.forms.ezw.EzwFormData

actual class EzwService(serializersModules: List<SerializersModule>? = null, requestFilter: (suspend RequestInit.() -> Unit)? = null) : IEzwService, KVRemoteAgent<EzwService>(EzwServiceManager, serializersModules, requestFilter) {
    override suspend fun nowy(token: String) = call(IEzwService::nowy, token)
    override suspend fun edycja(token: String) = call(IEzwService::edycja, token)
    override suspend fun sprawdz(ezwForm: EzwForm, token: String) = call(IEzwService::sprawdz, ezwForm, token)
    override suspend fun zapisz(ezwForm: EzwForm, validateResult: String?, token: String) = call(IEzwService::zapisz, ezwForm, validateResult, token)
    override suspend fun podglad(ezwForm: EzwForm, token: String) = call(IEzwService::podglad, ezwForm, token)
}
